module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hpGY7"))).then(() => parcelRequire('d0iPb'));